const messages = {
  sandbox: {
    registered: {
      title: "Thank You for Registering!",
      body: [
        "We'll send an authentication link to your email address to verify that it's yours.",
        "We're going to avoid spamming - so there may be a delay if you've made the request lots of times.",
        "Please check your junk or spam folder if you haven't seen anything soon.",
      ],
    },
    confirmed: {
      title: "Thank you for confirming your email address!",
      body: [
        "We'll send you your new random username and password - you'll be investigating our sample data in no time.",
      ],
    },
  },
};

export default messages;
